import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { bidsTranslations } from "@krea/customer-features/shared-components/bid-dashboards/translations";
import { getPrimaryLanguage } from "@krea/customer-features/utils";
import { agentsTranslations } from "@krea/shared/features/agents/translations";
import { bankIDTranslations } from "@krea/shared/features/bankID";

const namespaces = [
  "partnerWeb",
  "partnerApplication",
  bankIDTranslations.namespace,
  bidsTranslations.namespace,
  agentsTranslations.namespace,
  "common",
];
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        partnerWeb: require("./translations/partner/en.json"),
        common: require("@krea/customer-features/translations/common/en.json"),
        partnerApplication: require("@krea/customer-features/shared-components/partner-application-form/translations/en.json"),
        [bankIDTranslations.namespace]: bankIDTranslations.en,
        [bidsTranslations.namespace]: bidsTranslations.en,
        [agentsTranslations.namespace]: agentsTranslations.en,
      },
      sv: {
        partnerWeb: require("./translations/partner/sv.json"),
        common: require("@krea/customer-features/translations/common/sv.json"),
        partnerApplication: require("@krea/customer-features/shared-components/partner-application-form/translations/sv.json"),
        [bankIDTranslations.namespace]: bankIDTranslations.sv,
        [bidsTranslations.namespace]: bidsTranslations.sv,
        [agentsTranslations.namespace]: agentsTranslations.sv,
      },
      fi: {
        partnerWeb: require("./translations/partner/fi.json"),
        common: require("@krea/customer-features/translations/common/fi.json"),
        partnerApplication: require("@krea/customer-features/shared-components/partner-application-form/translations/fi.json"),
        [bankIDTranslations.namespace]: bankIDTranslations.fi,
        [bidsTranslations.namespace]: bidsTranslations.fi,
        [agentsTranslations.namespace]: agentsTranslations.fi,
      },
    },
    lng: getPrimaryLanguage(),
    fallbackLng: "en",
    supportedLngs: ["sv", "en", "fi"],
    ns: namespaces,
    defaultNS: namespaces,
    fallbackNS: namespaces,
    interpolation: {
      escapeValue: false,
    },
    react: {
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p", "ul", "li"],
    },
  });

// eslint-disable-next-line import/no-default-export
export default i18n;
